// extracted by mini-css-extract-plugin
export default {"container":"styles__container--e3fe93c235b9dafbfbf0"};